import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/bg")({
  component: () => <Outlet />,
});
